<template>
    <div>
      <b-container class="mt-5 mb-5">

        <b-button to="/manage/organisation/locations/create" variant="primary" class="float-right">
          Locatie toevoegen
        </b-button>
        <b-button @click="showModal" variant="outline-primary" class="float-right mr-2">
          Locatie uitnodigen
        </b-button>
        <h1 class="fs-4 font-weight-bold mb-0">Locaties</h1>
        <p class="text-muted">Waar vinden evenementen plaats?</p>

        <template v-if="!locations.length">
          <b-card no-body>
            <b-card-body>
                <div class="text-center text-muted mt-4 mb-4">
                    <font-awesome-icon icon="map-marker" class="mb-2" size="2x" />
                    <div class="text-dark fs-5">Geen locaties gevonden.</div>
                    <div>Voeg een locatie toe voor uw evenementen.</div>
                </div>
            </b-card-body>
          </b-card>
        </template>

        <template v-else>
          <b-list-group class="shadow">
            <b-list-group-item v-for="(location, key) in locations" :key="key" :to="`/manage/organisation/locations/edit/` + location.id">
                <div class="float-left">
                    <font-awesome-icon class="intro-icon mt-1" icon="fa-solid fa-map-marker" size="2x" />
                </div>
                <div class="icon-text">
                    <font-awesome-icon class="arrow-icon float-right" icon="fa-solid fa-chevron-right" />
                    <div>{{ location.name }}</div>
                    <p v-if="location.place" class="text-muted mb-0">{{ location.place }}</p>
                </div>
            </b-list-group-item>
          </b-list-group>
        </template>
      </b-container>

      <b-modal ref="addLocationModal" title="Nieuwe locatie uitnodigen" hide-footer>
        <form @submit.prevent="inviteLocation" novalidate="novalidate">
          <ValidationObserver ref="invform" slim>
            <div class="mb-3">
              <p class="text-muted mb-2">Stuur onderstaande aanmeldlink zodat locaties zichzelf kunnen aanmelden.</p>
              <b-form-input v-model="invitelink" readonly />
            </div>

            <div class="text-center text-muted mt-2 mb-2 font-italic h4">of</div>
            <hr/>

            <b-alert variant="success" show v-if="isInviteSuccess">
                De uitnodiging is succesvol verzonden.
            </b-alert>

            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="mb-3">
                <p class="text-muted mb-2">Stuur een aanmeldmail zodat locaties zichzelf kunnen aanmelden.</p>
                <b-form-input v-model="form.email" placeholder="voorbeeld@email.nl" />
                <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>

            <b-button
              type="submit"
              variant="primary"
              block
            >
              Locatie uitnodigen
            </b-button>
          </ValidationObserver>
        </form>
      </b-modal>
    </div>
  </template>
  
  <script>
    import { ValidationObserver, ValidationProvider } from 'vee-validate';
    import { mapActions } from 'pinia'
    import { useShopStore } from '@/stores/shop'

    export default {
        metaInfo: {
            title: 'Locaties',
        },
        components: {
          ValidationObserver,
          ValidationProvider,
        },
        data() {
            return {
              invitelink: '',
              isInviteSuccess: false,
              form: {
                email: '',
              },
              locations: [],
            }
        },
        computed: {},
        methods: {
          ...mapActions(useShopStore, ['setLoading']),
          getLocations: function() {
            this.setLoading(true);
            this.$axios.get("https://api.tixgo.nl/locations")
              .then( response => {
                this.locations = response.data;
                this.setLoading(false);
            }).catch(response => { console.log(response); });
          },
          getInviteCode: function() {
            this.setLoading(true);
            this.$axios.get("https://api.tixgo.nl/locations/invitelink")
              .then( response => {
                this.invitelink = response.data.link;
            }).catch(response => { console.log(response); }); 
          },
          showModal() {
            this.$refs.addLocationModal.show();
          },
          async inviteLocation() {
            let check = await this.$refs['invform'].validate();

            if (!check) {
              window.scrollTo({
                top: 0,
                behavior: "smooth"
              });
              
              return;
            }
            
            this.$axios.post("https://api.tixgo.nl/locations/invite", this.form)
                .then( response => {
                if (response.data.status == 'success') {
                  this.form.email = '';
                  this.isInviteSuccess = true;
                }
            });
          }
        },
        created() {
          this.getLocations();
          this.getInviteCode();
        }
    }
</script>
  
<style scoped>
.intro-icon{
    background-color:#CA355B;
    font-size: 25px;
    padding:8px;
    color:#fff;
    border-radius:10px;
    height:25px;
    width:25px;
}
.icon-text{
    padding-left:60px;
}
.arrow-icon{
    float:right;
    top:50%;
    margin-top:15px;
    padding-left:15px;
    color:#999;
}
</style>